<template>
    <div class="page">
        <transition name="fade-transform">
            <router-view :key="key" />
        </transition>
    </div>
</template>

<script>
    export default {
        computed: {
            key() {
                return this.$route.path
            },
            // cachedViews() {
            //     return this.$store.state.tagsView.cachedViews
            // },
        },
    }
</script>

<style lang="scss" scoped>
    @import "@/styles/transition.scss";
    .page {
        height: 100%;
        overflow: auto;
        padding: 20px;
        box-sizing: border-box;
        position: absolute;
        width: calc(100% - 260px);
        right: 0;
        background: #f3fafb;
        box-sizing: border-box;
        overflow-y: hidden;
    }
</style>



// WEBPACK FOOTER //
// src/pages/home/home_detail.vue